var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('div',{staticClass:"modal-content"},[_c('activity-indicator',{attrs:{"text":_vm.text}})],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }